import transform from '@/services/catalogue/filters/produitServerTableDataTransformer';

export default function transformer(serverTableData) {
  if (serverTableData.orderBy === 'produitReseau.adresse.ville') {
    serverTableData.orderBy = 'Ville';
  }
  return transform(serverTableData);
}
